import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "#283570",
      "clip-path": "url(#i1788119731__a)"
    }, [
      _createElementVNode("path", { d: "M2 8h20v2H2zM2 14h20v2H2z" })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "i1788119731__a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h24v24H0z"
        })
      ])
    ], -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "hamburger"}) } }